<template>
    <template v-if="type === 'checked'">
        <svg :class="class" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px"
            height="10px" viewBox="0 0 15 10" version="1.1">
            <title>路径</title>
            <g id="LEMMO-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="1.1版本-勾选协议" transform="translate(-150.000000, -650.000000)" :fill="color" fill-rule="nonzero">
                    <g id="编组-5" transform="translate(150.000000, 647.000000)">
                        <g id="对号,勾,正确,完成" transform="translate(0.000000, 3.000000)">
                            <path
                                d="M14.3868727,1.98965126 L6.64233059,9.73419337 C6.28792175,10.0886022 5.71377942,10.0886022 5.35937057,9.73419337 L0.0659200454,4.44074284 C-0.0219733485,4.35284945 -0.0219733485,4.20825064 0.0659200454,4.12035724 L1.66926566,2.51701162 C1.75715906,2.42911823 1.90175787,2.42911823 1.98965126,2.51701162 L5.91933655,6.44669691 C5.96328324,6.49064361 6.03558265,6.49064361 6.07952935,6.44669691 L12.4617238,0.0659200454 C12.5496172,-0.0219733485 12.694216,-0.0219733485 12.7821094,0.0659200454 L14.3854551,1.66926566 C14.4747661,1.75715906 14.4747661,1.90175787 14.3868727,1.98965126 Z"
                                id="路径"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </template>
    <template v-if="type === 'arrow'">
        <svg t="1681967325116" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="3439" width="16" height="16">
            <path
                d="M183.168 332.501333a42.666667 42.666667 0 0 1 57.621333-2.496l2.709334 2.496L512 600.96l268.501333-268.48a42.666667 42.666667 0 0 1 57.621334-2.496l2.709333 2.496a42.666667 42.666667 0 0 1 2.496 57.621333l-2.496 2.709334-298.666667 298.666666a42.666667 42.666667 0 0 1-57.621333 2.496l-2.709333-2.496-298.666667-298.666666a42.666667 42.666667 0 0 1 0-60.330667z"
                fill="currentColor" p-id="3440"></path>
        </svg>
    </template>
    <template v-if="type === 'close'">
        <!-- <svg t="1657642763277" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="2248" width="20" height="20">
            <path
                d="M550.848 502.496l308.64-308.896a31.968 31.968 0 1 0-45.248-45.248l-308.608 308.896-308.64-308.928a31.968 31.968 0 1 0-45.248 45.248l308.64 308.896-308.64 308.896a31.968 31.968 0 1 0 45.248 45.248l308.64-308.896 308.608 308.896a31.968 31.968 0 1 0 45.248-45.248l-308.64-308.864z"
                p-id="2249"></path>
        </svg> -->
        <svg focusable="false" width="14" height="14" viewBox="0 0 14 14">
            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.5" fill="none"></path>
        </svg>
    </template>
    <template v-if="type === 'next-step'">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="图层_1" data-name="图层 1"
            viewBox="0 0 25.33 16">
            <defs>
                <clipPath id="clip-path" transform="translate(0)">
                    <rect class="cls-1" style="fill: none;" width="25.33" height="16" />
                </clipPath>
            </defs>
            <title>Lemo _ Next Step Arrow</title>
            <g id="Group_361" data-name="Group 361">
                <g class="cls-2" style=" clip-path: url(#clip-path);">
                    <g id="Group_326" data-name="Group 326">
                        <path id="Path_64" data-name="Path 64" style=" fill: none; stroke: #1b1b19;
                        stroke-miterlimit: 10;stroke-width: 1.3px;" class="cls-3"
                            d="M17.33,16a8,8,0,0,1,8-8,8,8,0,0,1-8-8" transform="translate(0)" />
                        <line id="Line_125" data-name="Line 125" class="cls-4" style="  stroke: #1b1b19;
                        stroke-miterlimit: 10; fill: none;  stroke-width: 1.23px;" x1="24" y1="8" y2="8" />
                    </g>
                </g>
            </g>
        </svg>
    </template>
    <template v-if="type === 'plus'">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="11px" height="11px" viewBox="0 0 11 11" version="1.1">
            <title>形状结合@1x</title>
            <g id="step2" stroke="currentColor" stroke-width="1" fill="currentColor" fill-rule="evenodd" stroke-linecap="square">
                <g id="选择配件页" transform="translate(-245.500000, -246.500000)">
                    <g id="编组-4" transform="translate(157.000000, 236.000000)">
                        <path d="M89,16 L99,16 M94,11 L94,21" id="形状结合"/>
                    </g>
                </g>
            </g>
        </svg>
    </template>
    <template v-if="type === 'minus'">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="11px" height="1px" viewBox="0 0 11 1" version="1.1">
            <title>直线 10备份@1x</title>
            <g id="step2" stroke="currentColor" stroke-width="1" fill="currentColor" fill-rule="evenodd" stroke-linecap="square">
                <g id="选择配件页" transform="translate(-167.000000, -252.000000)" >
                    <g id="编组-4" transform="translate(157.000000, 236.000000)">
                        <line x1="10.5" y1="16.5" x2="20.5" y2="16.5" id="直线-10备份"/>
                    </g>
                </g>
            </g>
        </svg>
    </template>

</template>

<script>
export default {
    name: 'cyIcon',
    props: {
        type: {
            type: String,
            default: 'checked'
        },
        color: {
            type: String,
            default: '#fff'
        },
        class: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="less" scoped></style>